export default {"src":"/_next/static/media/settingsActive.f8b00c3d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};